"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.pureTranslate = void 0;

var _useDictionary = _interopRequireDefault(require("../hooks/useDictionary"));

var _enGB = _interopRequireDefault(require("../data/dictionary/en-GB.json"));

var pureTranslate = function pureTranslate(translations, key) {
  var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var translation = translations[key] || _enGB.default[key];

  if (!translation) {
    return key;
  }

  return Object.keys(values).reduce(function (acc, placeholder) {
    return acc.replace(new RegExp("__".concat(placeholder, "__"), "g"), String(values[placeholder]));
  }, translation);
};

exports.pureTranslate = pureTranslate;

var Translate = function Translate(_ref) {
  var tKey = _ref.tKey,
      values = _ref.values;
  var dictionary = (0, _useDictionary.default)();
  return pureTranslate(dictionary, tKey, values);
};

var _default = Translate;
exports.default = _default;